module.exports = __webpack_public_path__ + "img/SC3-About_you.be3e85b0.png";